import React, { useState } from 'react';

const COVERAGE_OPTIONS = [
  { value: 'Personal Auto', label: 'Personal Auto', icon: '🚗', desc: 'Cars, trucks, motorcycles' },
  { value: 'Homeowners', label: 'Homeowners', icon: '🏠', desc: 'House & property coverage' },
  { value: 'Renters', label: 'Renters', icon: '🛋️', desc: 'Apartment & belongings' },
  { value: 'Business Owners Policy', label: 'BOP', icon: '🏢', desc: 'Small business package' },
  { value: 'Commercial General Liability', label: 'General Liability', icon: '🛡️', desc: 'Business liability protection' },
  { value: 'Workers Compensation', label: "Workers' Comp", icon: '👷', desc: 'Employee injury coverage' },
  { value: 'Commercial Auto', label: 'Commercial Auto', icon: '🚚', desc: 'Business vehicles' },
  { value: 'Umbrella', label: 'Umbrella / Excess', icon: '☂️', desc: 'Extra liability coverage' },
];

export default function QuoteStepCoverage({ value, zip, onChange }) {
  const [selectedType, setSelectedType] = useState(value || '');
  const [zipValue, setZipValue] = useState(zip || '');
  const [zipError, setZipError] = useState('');

  const handleZipChange = (val) => {
    setZipValue(val);
    if (zipError) setZipError('');
  };

  const handleContinue = () => {
    if (!selectedType) return;
    if (!/^\d{5}$/.test(zipValue)) {
      setZipError('Please enter a valid 5-digit ZIP code.');
      return;
    }
    onChange({ coverage_type: selectedType, estimate_zip: zipValue });
  };

  const canContinue = selectedType && /^\d{5}$/.test(zipValue);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-2">What type of coverage do you need?</h2>
        <p className="text-gray-500">Select one to get started. You can request additional types later.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {COVERAGE_OPTIONS.map((opt) => {
          const selected = selectedType === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => setSelectedType(opt.value)}
              className={`relative p-4 rounded-xl border-2 text-left transition-all duration-200 hover:border-[#1e3a5f] focus:outline-none ${
                selected
                  ? 'border-[#1e3a5f] bg-[#1e3a5f] text-white shadow-md'
                  : 'border-gray-200 bg-white text-gray-700 hover:shadow-sm'
              }`}
            >
              {selected && (
                <div className="absolute top-2 right-2 w-5 h-5 bg-[#c9a84c] rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              <div className="text-2xl mb-2">{opt.icon}</div>
              <div className={`font-semibold text-sm mb-1 ${selected ? 'text-white' : 'text-gray-900'}`}>
                {opt.label}
              </div>
              <div className={`text-xs leading-tight ${selected ? 'text-blue-100' : 'text-gray-500'}`}>
                {opt.desc}
              </div>
            </button>
          );
        })}
      </div>

      {/* ZIP input */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Your ZIP Code <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={zipValue}
          onChange={(e) => handleZipChange(e.target.value.replace(/\D/g, '').slice(0, 5))}
          placeholder="90703"
          maxLength={5}
          className={`w-full max-w-xs px-4 py-3 rounded-lg border-2 text-lg focus:outline-none transition-colors ${
            zipError
              ? 'border-red-400 focus:border-red-500'
              : 'border-gray-200 focus:border-[#1e3a5f]'
          }`}
        />
        {zipError && (
          <p className="text-red-500 text-sm mt-1">{zipError}</p>
        )}
      </div>

      <button
        onClick={handleContinue}
        disabled={!canContinue}
        className="w-full bg-[#1e3a5f] hover:bg-[#162d4a] disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold py-3.5 rounded-xl transition-colors"
      >
        Continue
      </button>
    </div>
  );
}
